import { RecibosFormValues, RecibossMod } from "../../../app/models/RecibosMod";
import { MySelectInput } from "../../../app/common/form/MySelectInput";
import MyTextInput from "../../../app/common/form/MyTextInput";
import MyTextArea from "../../../app/common/form/MyTextArea";
import { useStore } from "../../../app/stores/store";
import "../CCTCuenta/pagotarjeta.css";
import { useHistory, useParams } from "react-router";
import { Button, Form, Header, Segment } from "semantic-ui-react";
import ReCAPTCHA from "react-google-recaptcha";
import { toast } from "react-toastify";
import { Formik } from "formik";
import Swal from "sweetalert2";
import * as Yup from "yup";

import Validars, { deviceFingerPrintID, merchantID } from "./sripts";
import React, { useEffect, useState, useRef } from "react";
import { boolean } from "yup/lib/locale";
import { MutableRefObject } from "react";

interface Props {
  cliente: any;
  cuenta: any;
  saldo: any;
  descripcion: any;
}

export default function PagoTarjeta(props: Props) {
  const [captchaValido, cambiarCaptchaValido] = useState<boolean | null>(null);
  const myCaptcha = useRef() as MutableRefObject<ReCAPTCHA>;
  const history = useHistory();
  const onChange = () => {
    if (myCaptcha.current?.getValue()) {
      cambiarCaptchaValido(true);
    } else {
      cambiarCaptchaValido(false);
    }
  };

  const {
    userStore: { user },
    InscriptionsStore,
    modalStore,
    recibosStore,
    SGPersonaStore: { SGPersonaByName, loadSGPersona },
  } = useStore();
  const { CCTCuentaStore } = useStore();
  const { createRecibosMod, crearPdfRecibo, loading } = recibosStore;
  const [RecibossMod, setCCTipoDeDocumento] = useState<RecibosFormValues>(
    new RecibosFormValues()
  );

  const { loadCCTCuenta, CCTCuentaByCodigo, saldo_actual_total } =
    CCTCuentaStore;
  const nf = new Intl.NumberFormat("en-IN");

  var date: Date = new Date();
  var id: string | undefined = user?.id;
  let numtarjeta: string = "";

  const [nombre, setNombre] = useState("");
  const [mess, setMess] = useState("");
  const [ages, setAges] = useState("");
  const [ccv, setCcv] = useState("");
  const [t1, setT1] = useState("");
  const [t2, setT2] = useState("");
  const [t3, setT3] = useState("");
  const [t4, setT4] = useState("");
  const [imagen, setImagen] = useState("/app/images/tarjeta.png");
  const [btn, setBtn] = useState(true);
  const [btn2, setBtn2] = useState(true);

  const validationSchema = Yup.object().shape({
    t1: Yup.string().min(4).max(4).required("Obligatorio"),
    t2: Yup.string().min(4).max(4).required("Obligatorio"),
    t3: Yup.string().min(4).max(4).required("Obligatorio"),
    t4: Yup.string().min(4).max(4).required("Obligatorio"),
    ccv: Yup.string().min(4).max(4).required("Obligatorio"),
  });

  let key, value: any;
  var element2: any;
  var nombreT: string;
  var apellidoT: string;

  const myCambiar = () => {
    const element = (document.getElementById("alumno") as HTMLInputElement)
      .value;
    setNombre(element);
  };

  const myCambiarM = () => {
    const element = (document.getElementById("mest") as HTMLInputElement).value;
    setMess(element + " / ");
  };

  const myCambiarA = () => {
    const element = (document.getElementById("aget") as HTMLInputElement).value;
    setAges(element);
  };

  const myCambiarC = () => {
    const element = (document.getElementById("ccv") as HTMLInputElement).value;
    (document.getElementById("ccv") as HTMLInputElement).value = element
      .replace(/\s/g, "")
      .replace(/\D/g, "");

    setCcv(element);

    const saltarinput = (document.getElementById("ccv") as HTMLInputElement)
      .value.length;

    if (saltarinput == 3) {
      var estadobtn2: boolean = false;
      setBtn2(estadobtn2);
    } else if (saltarinput < 3) {
      var estadobtn: boolean = true;
      var estadobtn2: boolean = true;

      setBtn(estadobtn);
      setBtn2(estadobtn2);
    }
  };

  var tipoTarjeta: string;

  const myCambiarT1 = () => {
    const element = (document.getElementById("t1") as HTMLInputElement).value;
    (document.getElementById("t1") as HTMLInputElement).value = element
      .replace(/\s/g, "")
      .replace(/\D/g, "");

    setT1(element);
    tipoTarjeta = element.substring(0, 1);
    if (tipoTarjeta == "4") {
      setImagen("/app/images/VISA.png");
    } else if (tipoTarjeta == "5") {
      setImagen("/app/images/MASTER.png");
    } else if (tipoTarjeta == "3") {
      setImagen("/app/images/AEXPRES.png");
    } else {
      setImagen("/app/images/tarjeta.png");
    }

    const saltarinput = (document.getElementById("t1") as HTMLInputElement)
      .value.length;

    if (saltarinput == 4) {
      const focuss = document.getElementById("t2") as HTMLInputElement;
      focuss.focus();
    }
  };

  const myCambiarT2 = () => {
    const element = (document.getElementById("t2") as HTMLInputElement).value;

    (document.getElementById("t2") as HTMLInputElement).value = element
      .replace(/\s/g, "")
      .replace(/\D/g, "");
    setT2(element);

    const saltarinput = (document.getElementById("t2") as HTMLInputElement)
      .value.length;

    if (saltarinput == 4) {
      const focuss = document.getElementById("t3") as HTMLInputElement;
      focuss.focus();
    } else if (saltarinput < 1) {
      const focuss = document.getElementById("t1") as HTMLInputElement;
      focuss.focus();
    }
  };

  const myCambiarT3 = () => {
    const element = (document.getElementById("t3") as HTMLInputElement).value;
    (document.getElementById("t3") as HTMLInputElement).value = element
      .replace(/\s/g, "")
      .replace(/\D/g, "");
    setT3(element);

    const saltarinput = (document.getElementById("t3") as HTMLInputElement)
      .value.length;

    if (saltarinput == 4) {
      const focuss = document.getElementById("t4") as HTMLInputElement;
      focuss.focus();
    } else if (saltarinput < 1) {
      const focuss = document.getElementById("t2") as HTMLInputElement;
      focuss.focus();
    }
  };
  //   let numtarjeta: string = "1"

  const myCambiarT4 = () => {
    const element = (document.getElementById("t4") as HTMLInputElement).value;
    (document.getElementById("t4") as HTMLInputElement).value = element
      .replace(/\s/g, "")
      .replace(/\D/g, "");
    setT4(element);

    const saltarinput = (document.getElementById("t4") as HTMLInputElement)
      .value.length;

    if (saltarinput > 3) {
      const focuss = document.getElementById("mest") as HTMLInputElement;
      focuss.focus();
    }

    numtarjeta =
      (document.getElementById("t1") as HTMLInputElement).value +
      (document.getElementById("t2") as HTMLInputElement).value +
      (document.getElementById("t3") as HTMLInputElement).value +
      (document.getElementById("t4") as HTMLInputElement).value;
  };

  var VISA = /^4[0-9]{3}-?[0-9]{4}-?[0-9]{4}-?[0-9]{4}$/;
  var MASTERCARD = /^5[1-5][0-9]{2}-?[0-9]{4}-?[0-9]{4}-?[0-9]   {4}$/;
  var AMEX = /^3[47][0-9-]{16}$/;

  function fValidarTarjeta() {
    numtarjeta =
      (document.getElementById("t1") as HTMLInputElement).value +
      (document.getElementById("t2") as HTMLInputElement).value +
      (document.getElementById("t3") as HTMLInputElement).value +
      (document.getElementById("t4") as HTMLInputElement).value;

    var opt = "VISA";
    var codigo = numtarjeta;
    var msg = "Valor incorrecto";

    if (luhn(codigo)) {
      if (opt == "VISA" && !codigo.match(VISA)) {
        Swal.fire("Numero de tarjeta es incorrecto");
      }
      if (opt == "MASTERCARD" && !codigo.match(MASTERCARD)) {
        Swal.fire("Numero de tarjeta es incorrecto");
      }

      if (opt == "AMEX" && !codigo.match(AMEX)) {
        Swal.fire("Numero de tarjeta es incorrecto");
      }
    } else {
      Swal.fire("Numero de tarjeta es incorrecto");
    }
  }

  function luhn(value: any) {
    // Accept only digits, dashes or spaces
    if (/[^0-9-\s]+/.test(value)) return false;
    // The Luhn Algorithm. It's so pretty.
    let nCheck = 0,
      bEven = false;
    value = value.replace(/\D/g, "");
    for (var n = value.length - 1; n >= 0; n--) {
      var cDigit = value.charAt(n),
        nDigit = parseInt(cDigit, 10);
      if (bEven && (nDigit *= 2) > 9) nDigit -= 9;
      nCheck += nDigit;
      bEven = !bEven;
    }
    return nCheck % 10 == 0;
  }

  const modalTimer = () => {
    let timerInterval: any;
    Swal.fire({
      position: "center",
      title: "Espere porfavor.",
      html: "Estamos generando su recibo.",
      timer: 8800,
      timerProgressBar: true,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      willClose: () => {
        clearInterval(timerInterval);
      },
    }).then((result) => {
      if (result.dismiss === Swal.DismissReason.timer) {
      }
    });
  };

  const modalCierre = () => {
    let timerInterval: any;
    Swal.fire({
      position: "center",
      title: "Recibo Generado..",
      html: "Lo podrás descargar desde la página de tu perfil.",
      timer: 5000,
      timerProgressBar: true,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      willClose: () => {
        clearInterval(timerInterval);
      },
    }).then((result) => {
      if (result.dismiss === Swal.DismissReason.timer) {
      }
    });
  };

  const modalBasico = () => {
    Swal.fire({
      position: "center",
      icon: "success",
      title:
        "Datos confirmados.   Presione el botón verde para realizar su pago.",
      showConfirmButton: false,
      timer: 3500,
    });

    var estadobtn: boolean = false;
    var estadobtn2: boolean = true;

    setBtn(estadobtn);
    setBtn2(estadobtn2);
  };

  var saldo = nf.format(props.saldo);
  if (props.saldo % 1 == 0) {
    saldo = props.saldo + ".00";
  }

  function handleFormSubmit(RecibossMod: RecibosFormValues) {
    let date: Date = new Date();
    let id: any = user?.id;
    let dpi: string | undefined;
    let names: string | undefined;
    let apellidos: string | undefined;
    let nit: string | undefined;
    let qr: string | undefined;
    numtarjeta =
      (document.getElementById("t1") as HTMLInputElement).value +
      (document.getElementById("t2") as HTMLInputElement).value +
      (document.getElementById("t3") as HTMLInputElement).value +
      (document.getElementById("t4") as HTMLInputElement).value;
    const elementCcv = (document.getElementById("ccv") as HTMLInputElement)
      .value;
    const elementMes = (document.getElementById("mest") as HTMLInputElement)
      .value;
    const elementAño = (document.getElementById("aget") as HTMLInputElement)
      .value;

    var estadobtn: boolean = true;
    var estadobtn2: boolean = false;

    setBtn(estadobtn);
    setBtn2(estadobtn2);

    loadSGPersona(id).then((response) => {
      dpi = response?.dpi;
      apellidos = response?.apellidos;
      names = response?.nombres;
      nit = response?.nit;
      var descripcion = props.descripcion;

      const element = (document.getElementById("alumno") as HTMLInputElement)
        .value;
      setNombre(element);

      nombreT = element.toUpperCase().split(" ")[0];
      apellidoT = element.toUpperCase().split(" ")[1];

      let newRecibo: RecibossMod = {
        id_Recibo: 0,
        idCliente: id,
        cuenta: props.cuenta,
        monto: props.saldo,
        estado: "1",
        fechaEmision: date,
        CodigoQR: "",
        numeroTargeta: numtarjeta,
        ccv: elementCcv,
        mesCC: Number(elementMes),
        añoCC: Number(elementAño),
        nombreTarjeta: nombreT,
        apellidoTarjeta: apellidoT,
        deviceFingerPrintID: deviceFingerPrintID,
      };

      createRecibosMod(newRecibo, dpi, names, apellidos, nit, descripcion).then(
        (response) => {
          modalStore.closeModal();
          modalCierre();
        }
      );

    });
  }

  return (
    <>
      <Validars />
      <Segment className="modal_tarjeta">
        <div className="contenido_pagosT">
          <div className="datosstarjeta">
            <Formik
              enableReinitialize
              initialValues={RecibossMod}
              onSubmit={(values) => handleFormSubmit(values)}
            >
              {({ handleSubmit, isValid, isSubmitting, dirty }) => (
                <Form
                  className="ui form"
                  onSubmit={handleSubmit}
                  autoComplete="off"
                >
                  <input
                    type="hidden"
                    name="deviceFingerPrintID"
                    value={deviceFingerPrintID}
                  ></input>
                  <input
                    type="hidden"
                    name="merchantID"
                    value={merchantID}
                  ></input>

                  <div className="area_info_pago">
                    <div className="contenido_tarjeta_titulo">
                      <h2>Información de pago</h2>
                    </div>

                    <div className="info_doble">
                      <div className="info_area_izquierda">
                        <div className="sub_area_form">
                          <MyTextInput
                            label="Nombre del alumno:"
                            name="alumno"
                            placeholder=""
                            value={user?.displayName}
                          />
                        </div>

                        <div className="sub_area_form doble">
                          <div className="doble_mon">
                            <MyTextInput
                              label="Inversión en Q:"
                              name="monto"
                              placeholder={props.saldo.toFixed(2)}
                              value={props.saldo.toFixed(2)}
                              type="number"
                            />
                          </div>

                          <div className="doble_cod">
                            <MyTextInput
                              label="Código del curso:"
                              name="cuenta"
                              placeholder=""
                              value={String(props.cuenta)}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="info_area_derecha">
                        <div className="sub_textarea_form">
                          <MyTextArea
                            label="Descripción del pago:"
                            rows={4}
                            name="descripcion"
                            placeholder=""
                            value={props.descripcion}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="area_inferior">
                    <div className="contenido_tarjeta_titulo">
                      <h2>Datos de tarjeta</h2>
                    </div>

                    <div className="info_doble doble">
                      <div className="area_form_pago uno">
                        <div className="nombre_tarjeta">
                          <div>
                            <p>Nombre en la tarjeta</p>
                          </div>
                          <input
                            className="mayusc estilinput1"
                            name="alumno"
                            id="alumno"
                            maxLength={40}
                            placeholder="Ingrese su nombre"
                            onChange={myCambiar}
                          />
                        </div>

                        <div>
                          <p>No. Tarjeta</p>
                        </div>

                        <div className="area_numero_tarjeta triple">
                          <input
                            name="t1"
                            className="estilinput"
                            type="number"
                            id="t1"
                            placeholder="1234"
                            maxLength={4}
                            minLength={4}
                            required={true}
                            onChange={myCambiarT1}
                          />
                          <input
                            name="t2"
                            className="estilinput"
                            type="number"
                            id="t2"
                            placeholder="5534"
                            maxLength={4}
                            minLength={4}
                            required={true}
                            onChange={myCambiarT2}
                          />
                          <input
                            name="t3"
                            className="estilinput"
                            type="number"
                            id="t3"
                            placeholder="4244"
                            maxLength={4}
                            minLength={4}
                            required={true}
                            onChange={myCambiarT3}
                          />
                          <input
                            name="t4"
                            className="estilinput"
                            type="number"
                            id="t4"
                            placeholder="7544"
                            maxLength={4}
                            required={true}
                            onChange={myCambiarT4}
                          />
                        </div>

                        <div className="fechavencimiento doble">
                          <div>
                            <p>Mes</p>
                            <select
                              name="mest"
                              id="mest"
                              placeholder="12"
                              onChange={myCambiarM}
                              required={true}
                              defaultValue="0"
                            >
                              <option value="0" >
                                Selecciona
                              </option>
                              <option value="1">enero</option>
                              <option value="2">febrero</option>
                              <option value="3">marzo</option>
                              <option value="4">abril</option>
                              <option value="5">mayo</option>
                              <option value="6">junio</option>
                              <option value="7">julio</option>
                              <option value="8">agosto</option>
                              <option value="9">septiembre</option>
                              <option value="10">octubre</option>
                              <option value="11">noviembre</option>
                              <option value="12">diciembre</option>
                            </select>
                          </div>

                          <div>
                            <p>Año</p>
                            <select
                              name="aget"
                              id="aget"
                              placeholder="12"
                              onChange={myCambiarA}
                              required={true}
                              defaultValue="0"
                            >
                              <option value="0">
                                Selecciona
                              </option>
                              <option value="2022">2022</option>
                              <option value="2023">2023</option>
                              <option value="2024">2024</option>
                              <option value="2025">2025</option>
                              <option value="2026">2026</option>
                              <option value="2027">2027</option>
                              <option value="2028">2028</option>
                              <option value="2029">2029</option>
                              <option value="2030">2030</option>
                              <option value="2031">2031</option>
                              <option value="2032">2032</option>
                            </select>
                          </div>

                          <div>
                            <p>CCV</p>
                            <input
                              className="estilinput"
                              type="password"
                              id="ccv"
                              name="ccv"
                              placeholder="254"
                              maxLength={4}
                              minLength={3}
                              onClick={fValidarTarjeta}
                              onChange={myCambiarC}
                            />
                          </div>
                        </div>

                        {!captchaValido && (
                          <div className="captchaArea">
                            <p>
                              Por favor acepta el captcha para poder validar y
                              pagar.
                            </p>

                            <ReCAPTCHA
                              ref={myCaptcha}
                              sitekey="6LdywbgeAAAAAOUOFVWha3ZkMY_dvGzx6KvrjfK2"
                              onChange={onChange}
                            />
                         </div>
                        )}

                        {captchaValido && (
                          <div className="enviar">
                            <Button
                              className="blue"
                              id="btnconfirmar"
                              loading={loading}
                              disabled={btn2}
                              onClick={modalBasico}
                              content="Confirmar datos"
                            />

                            <Button
                              loading={InscriptionsStore.loadingBoton}
                              id="btnpagar"
                              className="green"
                              type="submit"
                              disabled={btn}
                              content="Realizar pago"
                              onClick={modalTimer}
                            />
                          </div>
                        )}
                      </div>

                      <div className="dos">
                        <div className="area_tarjeta">
                          <img className="tarjetaimg" src={imagen} alt="logo" />

                          <div className="tarjetacontainer">
                            <div className="vtarjeta">
                              <p>VENCE</p>
                              <p>
                                {mess}
                                {ages}
                              </p>
                            </div>

                            <div className="numero-area-tarjeta">
                              <input
                                className="numtarjeta1"
                                id="t1"
                                disabled
                                value={t1}
                              />

                              <input
                                className="numtarjeta2"
                                id="t2"
                                disabled
                                value={t2}
                              />

                              <input
                                className="numtarjeta3"
                                id="t3"
                                disabled
                                value={t3}
                              />

                              <input
                                className="numtarjeta4"
                                id="t4"
                                disabled
                                value={t4}
                              />
                            </div>

                            <div className="nametarjeta">
                              <p>{nombre}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </Segment>
    </>
  );
}
